"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("@app/routes/SpeechDevelopment/components/BoxComponentWithImg/index");
const styled_components_1 = __importDefault(require("styled-components"));
const react_1 = __importDefault(require("react"));
const BigImage = (0, styled_components_1.default)(index_1.Image) `
  max-width: 700px;
`;
const ExerciseRepetitionListWithBigImage = ({ list }) => (react_1.default.createElement(index_1.Container, null, list.map((item, i) => (react_1.default.createElement(index_1.Box, { key: i, style: { flexDirection: "column", alignItems: "center" } },
    react_1.default.createElement(index_1.ImageBox, { style: { justifyContent: "center" } },
        react_1.default.createElement(BigImage, { src: (item === null || item === void 0 ? void 0 : item.hint) || `https://via.placeholder.com/100?text=Image+${i + 1}`, alt: `Image ${i + 1}` })))))));
exports.default = ExerciseRepetitionListWithBigImage;
